<template>
  <div class="shrz">
    <el-dialog
      title="实名认证"
      width="500px"
	  :lock-scroll="false"
      :visible.sync="drawer">
      <el-form ref="form" :rules="rules" :model="form" label-width="70px" style="padding-right: 15px">
        <el-form-item label="姓名" prop="pxrXm">
          <el-input v-model="form.pxrXm"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="pxrSfz">
          <el-input v-model="form.pxrSfz"></el-input>
        </el-form-item>
        <el-button type="primary" @click="faceCheck()" style="margin-left: 70px">确定</el-button>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
	import { cookie } from "@/common/js/cookies.js";
  export default {
    name: "shrz",
    data() {
      return {
        // 标记从哪点进来  1是点视频  0是直接点实名认证
        sign: 0,
        drawer : false,
        form : {
          pxrSfz : null,
          pxrXm : null,
        },
        rules: {
          pxrXm: [
            {required: true, message: "请输入", trigger: "blur"},
            {min: 1, max: 10, message: "10个字以内", trigger: "blur"}
          ],
          pxrSfz: [
            {required: true,message: '请输入',trigger: 'blur'},
            {pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '你的身份证格式不正确' },
          ]
        },
        kcId: null,
      }
    },
    methods : {
      faceCheck: function (){
        let _self = this;

        this.$refs["form"].validate(valid => {
          if (valid) {
            let ajax = _self.$http.create();
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            ajax({
              method: 'post',
              url: SOWINURL + 'index/faceCheck',
              data : {
                sign: _self.sign,
                kcId: _self.kcId,
                pxrSfz : _self.form.pxrSfz,
                pxrXm : _self.form.pxrXm
              },
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
            }).then(function (json) {
              console.log(json.data);
              if (json.data.result == 1) {
                window.location.href = json.data.data.url;
              } else {
                _self.$message({
                  showClose: true,
                  message: json.data.errorcode,
                  type: 'error'
                });
              }
              loading.close();

            }).catch(function (error) {
              console.log(error);
            });
          }else {
            return false;
          }
        });


      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/shrz.vue